import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=1dfcb9a6&scoped=true"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfcb9a6",
  null
  
)

export default component.exports